module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ped-dentistry"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (!_vm.loading) ? _c('div', [_c('HeroSlider', {
    attrs: {
      "content": _vm.props
    }
  }), _c('Intro', {
    attrs: {
      "content": _vm.props
    }
  }), _c('TabsLeft', {
    attrs: {
      "props": _vm.props
    }
  }), _c('OPTabs', {
    attrs: {
      "content": _vm.props
    }
  }), _c('Appointments', {
    attrs: {
      "content": _vm.props
    }
  }), _c('FooterMain')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45b1fd9e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/ped-dentistry/ped-dentistry.pug
// module id = 630
// module chunks = 1